import {
  normalizeTenantHostname,
  isLocalDevHostname,
  isIpLiteralTenantHostname,
  isReservedAptTenantSubdomain,
} from '../tenant/hostUtils.js';
import { AMERICON_PRODUCT_HOST_SUFFIX } from './americonFlags.js';

const APT_ROOT_HOSTNAME = 'americanpolicetraining.com';

export function normalizeAmeriConHostname(input: string): string {
  return normalizeTenantHostname(input);
}

export function isAmeriConProductHostname(hostname: string): boolean {
  const normalized = normalizeAmeriConHostname(hostname);
  return normalized === AMERICON_PRODUCT_HOST_SUFFIX
    || normalized.endsWith(`.${AMERICON_PRODUCT_HOST_SUFFIX}`)
    || normalized.endsWith('.preview.conferences.americanpolicetraining.com');
}

export function isLikelyAmeriConPublicHostname(input: string): boolean {
  const hostname = normalizeAmeriConHostname(input);
  if (isLocalDevHostname(hostname) || isIpLiteralTenantHostname(hostname)) return false;
  if (hostname === APT_ROOT_HOSTNAME || hostname === `www.${APT_ROOT_HOSTNAME}`) return false;

  if (isAmeriConProductHostname(hostname)) {
    const sub = hostname.replace(`.${AMERICON_PRODUCT_HOST_SUFFIX}`, '').split('.')[0] || '';
    return sub.length > 0 && !isReservedAptTenantSubdomain(sub);
  }

  // Custom domain — not APT apex or reserved product zone
  if (!hostname.endsWith(`.${APT_ROOT_HOSTNAME}`)) {
    return true;
  }

  return false;
}

/** localhost / 127.0.0.1 with optional port — used for Vite dev preview. */
export function isAmeriConLocalDevHostname(hostname: string): boolean {
  return isLocalDevHostname(normalizeAmeriConHostname(hostname));
}

export function shouldMountAmeriConPublicRouter(options: {
  hostname: string;
  viteAmeriConEnabled: boolean;
  devPreviewEnabled: boolean;
}): boolean {
  const { hostname, viteAmeriConEnabled, devPreviewEnabled } = options;
  if (!viteAmeriConEnabled) {
    return false;
  }
  if (isLikelyAmeriConPublicHostname(hostname)) {
    return true;
  }
  return devPreviewEnabled && isAmeriConLocalDevHostname(hostname);
}

export function parseEditionPath(pathname: string): { editionSlug: string | null; subPath: string | null } {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return { editionSlug: null, subPath: null };
  const first = segments[0];
  if (first === 'archive' || first === 'terms' || first === 'privacy') {
    return { editionSlug: null, subPath: first };
  }
  if (/^\d{4}(-[a-z0-9-]+)?$/.test(first)) {
    return { editionSlug: first, subPath: segments[1] ?? null };
  }
  return { editionSlug: null, subPath: null };
}
